<template>
  <div class="enterprise-container wd-1200">

    <moduleTitle :large="true" :moduleFlag="moduleFlag" />

    <div class="enterprise-img-box" v-if="moduleInfo && moduleInfo.pcImage">
      <img class="enterprise-img" :src="moduleInfo.pcImage" />
    </div>
  </div>
</template>

<script>
  import moduleTitle from '@/components/pc/module-title';

  export default {
    components: { moduleTitle },
    props: {
      moduleInfo: {
        type: Object,
        default: () => {},
      },
      moduleFlag: {
        type: String,
        default: '',
      },
    }
  }
</script>

<style scoped lang="scss">
  .enterprise-container {
    padding-bottom: 20px;

    .enterprise-img-box {
      .enterprise-img {
        display: block;
        width: 100%; 
      }
    }
  }
</style>
